import {
  ColumnMenuModule,
  ColumnsToolPanelModule,
  ContextMenuModule,
  CellStyleModule,
  FiltersToolPanelModule,
  SetFilterModule,
  ServerSideRowModelModule,
} from "ag-grid-enterprise";

import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  DateFilterModule,
  ModuleRegistry,
  NumberFilterModule,
  TextFilterModule,
  ValidationModule,
  RowSelectionModule,
} from "ag-grid-community";

import React, { useContext, useEffect, useRef, useState } from "react";
import { ColDef } from "ag-grid-community";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faEye,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import useAgGridTheme from "../../gridUtils/agGridTheme";
import { getTheme } from "../../redux/themeSlice";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  changeSubscriptionStatus,
  deliverSubscription,
  getSubscriptionData,
  removeSubscription,
  setSubscriptionId,
  unSubscribeSubscription,
  updateSubscriptionStatus,
} from "../../redux/subscribeSlice";
import { showNotification } from "../../redux/notificationSlice";
import { ModalContext, useModal } from "../../components/Modal";
import SubscriptionModel from "./SubscriptionModel";
import Loading from "../../components/Loading";
import ConfirmPopup from "../../components/ConfirmPopup";
import { Button } from "../../components/button/Button";
import LoadingOverlay from "../../components/LoadingOverlay";
import { setLoading } from "../../redux/queryBuilderSlice";
import SearchInput from "../../components/SearchInput";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";

ModuleRegistry.registerModules([
  RowSelectionModule,
  ClientSideRowModelModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  ColumnMenuModule,
  ContextMenuModule,
  CellStyleModule,
  SetFilterModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  ValidationModule,
  ServerSideRowModelModule,
]);

const ToggleRenderer: React.FC<any> = ({
  value,
  data,
  setValue,
  setConfirmPopUp,
  setShowConfirmPopup,
  setLoading,
}) => {
  const [checked, setChecked] = useState<boolean>(value);
  const dispatch: AppDispatch = useDispatch();
  const theme = useSelector(getTheme);

  const handleChange = async () => {
    setShowConfirmPopup(true);

    setConfirmPopUp({
      title: `${checked ? "Pause" : "Resume"} Subscription`,
      message: (
        <>
          {" "}
          Do you want to {checked ? "pause" : "resume"} subscription{" "}
          <span
            style={{ color: theme.palette.primary.main, fontStyle: "italic" }}
          >
            {data.name}
          </span>{" "}
          ?{" "}
        </>
      ),

      confirmAction: async (title: string, id: number) => {
        setShowConfirmPopup(false);
        setLoading(true);
        const payload: any = new URLSearchParams();
        payload.append("id", data.id);
        payload.append("enabled", !checked ? 1 : 0);

        let changeStatus = await dispatch(changeSubscriptionStatus(payload));

        if (changeSubscriptionStatus.fulfilled.match(changeStatus)) {
          setLoading(false);

          const newVal = !checked;
          dispatch(
            updateSubscriptionStatus({
              id: data.id,
              status: newVal ? 1 : 0,
            }),
          );
          dispatch(
            showNotification({
              message: newVal
                ? "Subscription resumed successfully."
                : "Subscription paused successfully.",
              duration: 3000,
              isError: false,
            }),
          );

          // setChecked(newVal);
          // setValue(newVal);
        } else {
          setLoading(false);

          dispatch(
            showNotification({
              message: "An unexpected error occurred!",
              duration: 3000,
              isError: true,
            }),
          );
        }
        setShowConfirmPopup(false);
      },
      closeAction: () => {
        setLoading(false);

        setShowConfirmPopup(false);
      },
      id: 0,
    });
  };

  return (
    <label
      title={"Pause/Resume Subscription"}
      style={{
        display: "flex",
        cursor: "pointer",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        style={{ display: "none" }}
      />
      <span
        style={{
          width: "44px",
          height: "20px",
          display: "inline-block",
          background: checked ? "#4caf50" : "#ccc",
          borderRadius: "20px",
          position: "relative",
          transition: "0.3s",
        }}
      >
        <span
          style={{
            width: "18px",
            height: "18px",
            background: "#fff",
            borderRadius: "50%",
            position: "absolute",
            top: "1px",
            left: checked ? "24px" : "2px",
            transition: "0.3s",
          }}
        ></span>
      </span>
    </label>
  );
};

const ActionsRenderer: React.FC<any> = ({
  data,
  setConfirmPopUp,
  features,
  setShowConfirmPopup,
  setLoading,
}) => {
  const theme = useSelector(getTheme);
  const dispatch: AppDispatch = useDispatch();

  const handleUnsubscribe = async () => {
    setShowConfirmPopup(true);

    setConfirmPopUp({
      title: "Delete Subscription",
      message: (
        <>
          {" "}
          Do you want to delete subscription{" "}
          <span
            style={{ color: theme.palette.primary.main, fontStyle: "italic" }}
          >
            {data.name}
          </span>{" "}
          ?{" "}
        </>
      ),
      confirmAction: async (title: string, id: number) => {
        setShowConfirmPopup(false);
        setLoading(true);

        const payload: any = new URLSearchParams();
        payload.append("id", data.id);
        payload.append("multiList", "");
        payload.append("type", "");

        let unsubscribeItem = await dispatch(unSubscribeSubscription(payload));
        if (unSubscribeSubscription.fulfilled.match(unsubscribeItem)) {
          setLoading(false);

          dispatch(removeSubscription(data.id));
          dispatch(
            showNotification({
              message: "Subscription deleted successfully.",
              duration: 3000,
              isError: false,
            }),
          );
        } else {
          setLoading(false);

          dispatch(
            showNotification({
              message: "An unexpected error occurred!",
              duration: 3000,
              isError: true,
            }),
          );
        }
      },
      closeAction: () => {
        setShowConfirmPopup(false);
      },
    });
  };
  const viewModal = useModal(
    <SubscriptionModel mode="view" />,
    "subscriptionModel",
  );
  const editModal = useModal(
    <SubscriptionModel mode="edit" />,
    "subscriptionModel",
  );
  return (
    <div
      style={{
        display: "flex",
        height: "100%",
        justifyContent: "space-around",
        cursor: "pointer",
        alignItems: "center",
      }}
    >
      <FontAwesomeIcon
        icon={faEye}
        title="View"
        onClick={() => {
          viewModal();
          dispatch(setSubscriptionId(data.id));
        }}
      />
      <FontAwesomeIcon
        icon={faEdit}
        title="Edit"
        onClick={() => {
          editModal();
          dispatch(setSubscriptionId(data.id));
        }}
      />
      <FontAwesomeIcon
        icon={faTrash}
        onClick={handleUnsubscribe}
        title="Delete"
        color="red"
      />
      {features.includes("Advisor") && (
        <FontAwesomeIcon
          icon={faPaperPlane}
          title="Deliver"
          onClick={async () => {
            const payload: any = new URLSearchParams();
            payload.append("reports[]", data.id);
            payload.append("groupNames[]", "default");
            dispatch(deliverSubscription(payload));
            dispatch(
              showNotification({
                message: "Subscription is submitted for processing.",
                duration: 3000,
                isError: false,
              }),
            );
            // if (unSubscribeSubscription.fulfilled.match(deliverReport)) {
            //     dispatch(
            //           showNotification({
            //             message: "Report delivered successfully.",
            //             duration: 3000,
            //             isError: false,
            //           })
            //         );

            // }
          }}
        />
      )}
    </div>
  );
};

const SubscriptionList: React.FC = () => {
  const [searchText, setSearchText] = useState("");
  const [rowData, setRowData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useAgGridTheme(null);
  const { features = [] } = useSelector((state: RootState) => state.user.user);

  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [confirmPopUp, setConfirmPopUp] = useState({
    title: "",
    message: "",
    confirmAction: (title: string, id: number) => {},
    closeAction: () => {},
    id: 0,
  });
  const modalContext = useContext(ModalContext);
  const close = modalContext?.close ?? (() => {});
  const { subscriptionData = [], subscriptionDataLoading } = useSelector(
    (state: RootState) => state.subscribe,
  );
  const searchRef = useRef<HTMLInputElement | null>(null);

  const dispatch: AppDispatch = useDispatch();
  const fetchSubscriptionData = () => {
    dispatch(getSubscriptionData());
  };
  useEffect(() => {
    fetchSubscriptionData();
  }, [dispatch]);
  const columnDefs: ColDef[] = [
    // { headerName: "id", sort:"desc",hide:true, field: "id", flex: 1, cellStyle: { textAlign: 'center' } },

    { headerName: "Name", field: "name", flex: 1 },
    { headerName: "Query Name", field: "workbookName", flex: 1 },
    // { headerName: "File Type", field: "fileType", flex: 1 },
    {
      headerName: "Delivery Type",
      field: "deliveryModeType",
      flex: 1,
      cellStyle: { textAlign: "center" },
    },
    { headerName: "Subscribed By", field: "subscriber", flex: 1 },
    {
      headerName: "Created Date",
      field: "createdDateStr",
      flex: 1,
      cellStyle: { textAlign: "center" },
    },
    // { headerName: "createdDate", sort:"desc",hide:true, field: "createdDate", flex: 1, cellStyle: { textAlign: 'center' } },

    {
      headerName: "Status",
      field: "isEnabled",
      flex: 1,
      cellRenderer: (props: any) => (
        <ToggleRenderer
          {...props}
          setLoading={setIsLoading}
          setConfirmPopUp={setConfirmPopUp}
          setShowConfirmPopup={setShowConfirmPopup}
        />
      ),
    },

    {
      headerName: "Actions",
      field: "actions",
      flex: 1,
      cellRenderer: (props: any) => (
        <ActionsRenderer
          {...props}
          setLoading={setIsLoading}
          features={features}
          setConfirmPopUp={setConfirmPopUp}
          setShowConfirmPopup={setShowConfirmPopup}
        />
      ),
    },
  ];
  useEffect(() => {
    setRowData(subscriptionData);
  }, [subscriptionData]);
  return (
    <div className="dialog-container subscription-list">
      <LoadingOverlay show={isLoading} />
      <div
        className="dialog-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h3 className="dialog-title">Subscription Management</h3>

        <div>
          <SearchInput
            callback={(val) => {
              setSearchText(val);
            }}
            debounce={300}
            placeholder="Search" // Pass the clear function to SearchInput
            searchRef={searchRef}
          />
        </div>
      </div>

      <div
        className="ag-theme-alpine grid-wrapper saved-queries"
        style={{ padding: 15, width: "auto" }}
      >
        <div style={{ height: "100%", width: "100%" }}>
          {subscriptionDataLoading ? (
            <Loading show={true} />
          ) : rowData.length > 0 ? (
            <AgGridReact
              pagination={true}
              // paginationPageSize={5}
              suppressMoveWhenColumnDragging={true}
              suppressMoveWhenRowDragging={true}
              paginationAutoPageSize={false}
              quickFilterText={searchText}
              rowData={rowData}
              defaultColDef={{
                suppressMovable: true,
              }}
              columnDefs={columnDefs}
              theme={theme}
            />
          ) : (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No records found!
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          padding: "0px 15px 10px 15px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <div style={{}}>
          <Button
            className="btn sm"
            color="secondary"
            variant="outline"
            onClick={() => {
              close();
            }}
            style={{ textTransform: "capitalize" }}
          >
            Close
          </Button>
        </div>
      </div>
      {showConfirmPopup && (
        <ConfirmPopup
          title={confirmPopUp.title}
          id={confirmPopUp.id}
          message={confirmPopUp.message}
          confirmAction={confirmPopUp.confirmAction}
          closeAction={confirmPopUp.closeAction}
        ></ConfirmPopup>
      )}
    </div>
  );
};

export default SubscriptionList;
